import Layout from '@/layout/layout'

const renewalRouter = {
  path: '/renewalActivity',
  component: Layout,
  redirect: 'noRedirect',
  name: '换新活动',
  children: [
    {
      path: '/renewalActivity/renewalGoodsManagement',
      component: () => import('@/views/renewalActivity/renewalGoodsManagement/index'),
      name: '换新商品管理',
      meta: { title: '换新商品管理', noCache: true, fixed: true }
    }, {
      path: '/renewalActivity/renewalActivityManagement',
      component: () => import('@/views/renewalActivity/renewalActivityManagement/index'),
      name: '换新活动管理',
      meta: { title: '换新活动管理', noCache: true, fixed: true }
    }, {
      path: '/renewalActivity/renewOrder',
      component: () => import('@/views/renewalActivity/renewOrder/index'),
      name: '换新订单',
      meta: { title: '换新订单', noCache: true, fixed: true }
    },
  ]
}

export default renewalRouter
